import React, { useRef } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../firebase_conf";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import alertSfx from "../../src/alert_notif.wav";
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; //assign the value of ref to the argument
  }, [value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
}

const AlertComp = () => {
  const [incident_reports, setIncidentReport] = useState({});
  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
    document.getElementById("alert_sound").pause();
    document.getElementById("alert_sound").currentTime = 0;
  };

  useEffect(() => {
    const unsubscribed = onSnapshot(
      query(collection(db, "reported_incident")),
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            if(isReady){
              setPrevReport(incident_reports);
            }
            setIncidentReport({ id: change.doc.id, data: change.doc.data()});
            
          }
        });
      }
    );
    return () => {
      unsubscribed();
    };
  }, []);
  const [isReady, setIsReady] = useState(false);
  const [prevReport, setPrevReport] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(()=> {
    setTimeout(()=>{
      setIsLoading(false);
    }, 5000)

    return () => {
      setIsLoading(false);
    }
  },[])

  useEffect(() => {
    if (prevReport && isReady && prevReport.id !== incident_reports.id) {
      setOpen(true);
      document.getElementById("alert_sound").play();
    }
  }, [incident_reports]);

  return (
    <>
      <audio id="alert_sound" loop={true}>
        <source src={alertSfx} type="audio/wav" />
      </audio>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth={"sm"}
        disableEscapeKeyDown={true}
      >
        <DialogTitle id="alert-dialog-title">
          {"New message arrive!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            There is an emergency. Please respond immediately!!
          </DialogContentText>
          <div style={{ width: "100%", marginTop: "10px" }}>
            <Alert
              severity="warning"
              variant="outlined"
              style={{ marginBottom: "5px" }}
            >
              <b>Message:</b>{" "}
              {Object.keys(incident_reports).length !== 0 ? incident_reports.data.message:""}
            </Alert>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "75vh",
        }}
      >
        {!isReady ? (
          !isLoading ?(
            <Button variant="outlined" onClick={() => {setIsReady(true);setPrevReport(incident_reports)}}>
            Start Realtime Notification Listener
          </Button>
          ):(
            <CircularProgress />
          )
        ) : (
          <div id="wifi-loader" style={{ margin: "auto" }}>
            <svg className="circle-outer" viewBox="0 0 86 86">
              <circle className="back" cx="43" cy="43" r="40"></circle>
              <circle className="front" cx="43" cy="43" r="40"></circle>
              <circle className="new" cx="43" cy="43" r="40"></circle>
            </svg>
            <svg className="circle-middle" viewBox="0 0 60 60">
              <circle className="back" cx="30" cy="30" r="27"></circle>
              <circle className="front" cx="30" cy="30" r="27"></circle>
            </svg>
            <svg className="circle-inner" viewBox="0 0 34 34">
              <circle className="back" cx="17" cy="17" r="14"></circle>
              <circle className="front" cx="17" cy="17" r="14"></circle>
            </svg>
            <div className="text" data-text="Waiting..."></div>
          </div>
        )}
      </div>
    </>
  );
};

export default AlertComp;
